import { render, staticRenderFns } from "./editAttendanceClasses.vue?vue&type=template&id=8389f39e"
import script from "./editAttendanceClasses.vue?vue&type=script&lang=js"
export * from "./editAttendanceClasses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports